export const OPERATIONS = {
  READ: 'read',
  WRITE: 'write',
  PUBLISH: 'publish'
};
export const OPERATIONS_LIST = [OPERATIONS.READ, OPERATIONS.WRITE, OPERATIONS.PUBLISH];